import React, { useState } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Icon } from "@iconify/react";
import Comment from "./Comment";
import { GET_IMAGE } from "../../helpers/images";
import { UseCompanyColors } from "../../hooks/company";
import { orderBy } from "lodash";

const CommentList = ({
  comments = [],
  currentUser,
  jobId,
  onAddComment = () => {},
  onToggleFavorite = () => {},
  onEditComment = () => {},
  onDeleteComment = () => {},
}) => {
  const [content, setContent] = useState("");
  const { primaryColor } = UseCompanyColors();
  const brand = primaryColor || "#1B598E";

  const handleAddComment = () => {
    onAddComment(jobId, currentUser._id, content);
    setContent("");
  };

  const sortedComments = orderBy(comments, ["createdAt"], ["desc"]);
  return (
    <div 
      className="grid grid-flow-row auto-rows-max gap-y-5"
    >
      {sortedComments.map((comment) => (
        <Comment
          key={comment._id}
          jobId={jobId}
          comment={comment}
          currentUser={currentUser}
          onToggleFavorite={onToggleFavorite}
          onEditComment={onEditComment}
          onDeleteComment={onDeleteComment}
        />
      ))}

      <div className="flex items-center gap-3">
        <div className="flex-none w-10 h-10">
          {currentUser?.image ? (
            <img
              key={currentUser._id}
              className="w-10 h-10 rounded-full object-cover border-2 border-white dark:border-gray-800"
              src={GET_IMAGE(currentUser.image)}
              alt=""
            />
          ) : (
            <div className="w-10 h-10 rounded-full bg-indigo-400 flex items-center justify-center font-bold text-white text-sm border-2 border-white dark:border-gray-800">
              {currentUser?.firstName?.[0]}{currentUser?.lastName?.[0]}
            </div>
          )}
        </div>

        <div className="flex-auto relative">
          <input
            type="text"
            className="w-full text-sm text-gray-900 bg-gray-50 rounded-full border border-gray-300 pl-4 pr-12 py-[0.7rem] focus:ring-blue-500 focus:border-blue-500"
            placeholder="Write a comment..."
            onChange={(event) => setContent(event.target.value)}
            value={content}
          />
          <button
            type="button"
            aria-label="Send comment"
            className="absolute right-[6px] top-1/2 -translate-y-1/2 w-8 h-8 rounded-full flex items-center justify-center text-white transition-transform active:scale-90"
            onClick={handleAddComment}
            style={{ background: brand }}
          >
            <Icon icon="lucide:send" width="14" height="14" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CommentList;
